/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Tracking_Limit_CtaInputs */

const en_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to Student`)
};

const de_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Student upgraden`)
};

const fr_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Student`)
};

const es_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar a Student`)
};

const it_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna a Student`)
};

const nl_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade naar Student`)
};

const pl_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz do Student`)
};

const fi_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä Student-tasolle`)
};

const da_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader til Student`)
};

const sv_job_tracking_limit_cta = /** @type {(inputs: Job_Tracking_Limit_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera till Student`)
};

/**
* | output |
* | --- |
* | "Upgrade to Student" |
*
* @param {Job_Tracking_Limit_CtaInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const job_tracking_limit_cta = /** @type {((inputs?: Job_Tracking_Limit_CtaInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Tracking_Limit_CtaInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_tracking_limit_cta(inputs)
	if (locale === "fr") return fr_job_tracking_limit_cta(inputs)
	if (locale === "es") return es_job_tracking_limit_cta(inputs)
	if (locale === "it") return it_job_tracking_limit_cta(inputs)
	if (locale === "nl") return nl_job_tracking_limit_cta(inputs)
	if (locale === "pl") return pl_job_tracking_limit_cta(inputs)
	if (locale === "fi") return fi_job_tracking_limit_cta(inputs)
	if (locale === "da") return da_job_tracking_limit_cta(inputs)
	if (locale === "sv") return sv_job_tracking_limit_cta(inputs)
	return en_job_tracking_limit_cta(inputs)
});